import TodayIcon from "@mui/icons-material/Today";
import { CardContent, Typography } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import HowToRegOutlinedIcon from "@mui/icons-material/HowToRegOutlined";
import formatDate from "../FormatDate";
import AlarmIcon from "@mui/icons-material/Alarm";
import React from "react";

const EventCardDetails = ({
  dateRange,
  location,
  opening,
  expanded,
  deadline,
}) => {
  const now = new Date();

  return (
    <CardContent className="no-padding-bottom">
      <div className="event-time-row">
        <div>
          <TodayIcon className="calendar-icon" />
          <Typography component="p">{dateRange}</Typography>
        </div>
        <div style={{ display: "flex", flexShrink: 100 }}>
          {location && <LocationOnIcon className="location-on-icon" />}
          <Typography component="p">{location}</Typography>
        </div>
      </div>

      {opening && opening > now && expanded && (
        <div className="event-time-row">
          <div>
            <HowToRegOutlinedIcon />
            <Typography component="p">
              {"Inschrijven vanaf " + formatDate(opening, true, true)}
            </Typography>
          </div>
        </div>
      )}
      {deadline && expanded && (
        <div className="event-time-row">
          <div style={{ display: "flex" }}>
            <AlarmIcon />
            <Typography component="p">
              {"Inschrijven voor " + formatDate(deadline, true, true)}
            </Typography>
          </div>
        </div>
      )}
    </CardContent>
  );
};

export default EventCardDetails;
